var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHybrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187.203,
    height: 100.5,
    viewBox: "0 0 187.203 100.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_21226",
    "data-name": "Group 21226",
    transform: "translate(-307.52 -166.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21224",
    "data-name": "Group 21224"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "layer3",
    d: "M485.027,220.286V202.591H474.119v8.484Z",
    fill: "#ec6668"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M458.363,197.742,431.7,220.77v46.056h16.968v-24.24h19.391v24.24h16.968V220.289Z",
    fill: "#ffd592"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M422,226.831l36.359-29.089,36.36,29.089Z",
    fill: "#2b4263"
  })), /*#__PURE__*/React.createElement("path", {
    id: "opacity",
    d: "M458.363,197.742,431.7,219.073l-9.7,7.758h9.7v39.995h16.968v-24.24h9.7Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21021",
    "data-name": "Path 21021",
    d: "M379.965,260.357V173.683H312.7v86.67h21.992v-23.83h23.286v23.834Z",
    fill: "#bfdef4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21022",
    "data-name": "Path 21022",
    d: "M358.288,174.088H385.14v-7.762H307.52v7.762h26.851",
    fill: "#94b8e1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21023",
    "data-name": "Path 21023",
    d: "M334.687,236.523h23.286v30.3H334.687Z",
    fill: "#6379a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21024",
    "data-name": "Path 21024",
    d: "M334.687,236.523v5.682h19.4v24.621h3.881v-30.3Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21179",
    "data-name": "Group 21179"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21025",
    "data-name": "Path 21025",
    d: "M319.163,199.555h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21026",
    "data-name": "Path 21026",
    d: "M319.163,199.555v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21180",
    "data-name": "Group 21180"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21027",
    "data-name": "Path 21027",
    d: "M334.687,199.555h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21028",
    "data-name": "Path 21028",
    d: "M334.687,199.555v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21181",
    "data-name": "Group 21181"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21029",
    "data-name": "Path 21029",
    d: "M350.211,199.555h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21030",
    "data-name": "Path 21030",
    d: "M350.211,199.555v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21182",
    "data-name": "Group 21182"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21031",
    "data-name": "Path 21031",
    d: "M365.735,199.555H373.5v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21032",
    "data-name": "Path 21032",
    d: "M365.735,199.555v2.587h5.175v5.175H373.5v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21184",
    "data-name": "Group 21184"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21033",
    "data-name": "Path 21033",
    d: "M319.163,215.079h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21034",
    "data-name": "Path 21034",
    d: "M319.163,215.079v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21185",
    "data-name": "Group 21185"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21035",
    "data-name": "Path 21035",
    d: "M334.687,215.079h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21036",
    "data-name": "Path 21036",
    d: "M334.687,215.079v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21186",
    "data-name": "Group 21186"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21037",
    "data-name": "Path 21037",
    d: "M350.211,215.079h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21038",
    "data-name": "Path 21038",
    d: "M350.211,215.079v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21187",
    "data-name": "Group 21187"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21039",
    "data-name": "Path 21039",
    d: "M365.735,215.079H373.5v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21040",
    "data-name": "Path 21040",
    d: "M365.735,215.079v2.587h5.175v5.175H373.5v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21189",
    "data-name": "Group 21189"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21041",
    "data-name": "Path 21041",
    d: "M319.163,230.6h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21042",
    "data-name": "Path 21042",
    d: "M319.163,230.6v2.587h5.175v5.175h2.587V230.6Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21190",
    "data-name": "Group 21190"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21043",
    "data-name": "Path 21043",
    d: "M365.735,230.6H373.5v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21044",
    "data-name": "Path 21044",
    d: "M365.735,230.6v2.587h5.175v5.175H373.5V230.6Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21192",
    "data-name": "Group 21192"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21045",
    "data-name": "Path 21045",
    d: "M319.163,245.48h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21046",
    "data-name": "Path 21046",
    d: "M319.163,245.48v2.587h5.175v5.175h2.587V245.48Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21193",
    "data-name": "Group 21193"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21047",
    "data-name": "Path 21047",
    d: "M365.735,245.48H373.5v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21048",
    "data-name": "Path 21048",
    d: "M365.735,245.48v2.587h5.175v5.175H373.5V245.48Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21195",
    "data-name": "Group 21195"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21049",
    "data-name": "Path 21049",
    d: "M319.163,184.031h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21050",
    "data-name": "Path 21050",
    d: "M319.163,184.031v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21196",
    "data-name": "Group 21196"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21051",
    "data-name": "Path 21051",
    d: "M334.687,184.031h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21052",
    "data-name": "Path 21052",
    d: "M334.687,184.031v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21197",
    "data-name": "Group 21197"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21053",
    "data-name": "Path 21053",
    d: "M350.211,184.031h7.762v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21054",
    "data-name": "Path 21054",
    d: "M350.211,184.031v2.587h5.175v5.175h2.587v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21198",
    "data-name": "Group 21198"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21055",
    "data-name": "Path 21055",
    d: "M365.735,184.031H373.5v7.762h-7.762Z",
    fill: "#94b8e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21056",
    "data-name": "Path 21056",
    d: "M365.735,184.031v2.587h5.175v5.175H373.5v-7.762Z",
    fill: "#0d174c",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21057",
    "data-name": "Path 21057",
    d: "M307.52,260.357h27.167v6.468H307.52Zm50.453,0H385.14v6.468H357.973Z",
    fill: "#94b8e1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21225",
    "data-name": "Group 21225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21078",
    "data-name": "Path 21078",
    d: "M409.192,243.287H386.584l9.816-10.5a1.655,1.655,0,0,1,2.426,2.252h0l-4.588,4.939h14.954a1.655,1.655,0,1,1,0,3.309Z",
    fill: "#31a784"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21079",
    "data-name": "Path 21079",
    d: "M416.842,257.623a1.654,1.654,0,0,1-1.213-2.779l4.588-4.94H405.262a1.655,1.655,0,0,1,0-3.309H427.87l-9.815,10.5A1.648,1.648,0,0,1,416.842,257.623Z",
    fill: "#31a784"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybrid);
export default __webpack_public_path__ + "static/media/hybrid.2de5ecac671412dc301ac6a7ecb4109b.svg";
export { ForwardRef as ReactComponent };